import { planTypes, BILLING_CYCLE } from '@/common/constants';

export const isZoomSass = (selectedPlans = []) => {
  const isZoomSass = selectedPlans.find((p) => p.type === planTypes.EVENT_SAAS || p.type === planTypes.EVENT_SAAS_CORE);
  return isZoomSass && isZoomSass.billing_cycle !== BILLING_CYCLE.PAY_PER_ATTENDEE;
};
